import { get } from 'lodash';
import { hnAPI } from '../../constants/api';
import fetchApi from '../../services/fetch';
import { track, generateServerResponseError, generateMessageDisplayedSegment, identify } from 'utils/segmenTracker';
import {ACTIVATION, SERVER_RESPONSE_FAILED, MESSAGE_DISPLAYED } from 'constants/segmentEvents';
import { pageURLs } from 'constants/URLs';

const initialState = {
  data: {},
  isLoggedIn: false
};

export const auth = {
  state: { ...initialState },
  reducers: {
    updateAuthData(state, payload) {
      return {
        ...state,
        data: { ...state.data, ...payload }
      };
    },
    updateLoggedInStatus(state, payload) {
      return {
        ...state,
        isLoggedIn: payload
      };
    },
  },
  effects: dispatch => {
    return {
      async authenticate(params) {
        dispatch.apiStatus.setProcessing(true);
        fetchApi({
          method: "POST",
          url: hnAPI.accessToken,
          data: {
            code: params.code
          },
        })
          .then(response => {
            dispatch.auth.updateAuthData(response.data);
            localStorage.setItem('auth', btoa(JSON.stringify(response.data)))
            identify(response.data.pos_msisdn, {
              country: 'HN',
              currency: 'USD',
            })
            params.navigateTo && params.navigateTo()
            dispatch.apiStatus.setProcessing(false);
          })
          .catch(error => {
            dispatch.apiStatus.setRequestFailed({ ...error });
            track(SERVER_RESPONSE_FAILED, {...generateServerResponseError(error, ACTIVATION, 'Splash Screen', hnAPI.accessToken, 'Access Token API' )})
            track(MESSAGE_DISPLAYED, {...generateMessageDisplayedSegment(error, ACTIVATION, 'Access Token API')})
          });
      },
      async logout(cb) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: "POST",
          url: hnAPI.logout,
          data: {
            country: "HN"
          }
        })
          .then(() => {
            localStorage.clear()
            dispatch.apiStatus.setProcessing(false);
            dispatch.auth.clearStore();
            cb && cb();
          })
          .catch(error => {
            localStorage.clear();
            cb && cb()
            dispatch.apiStatus.setRequestFailed({ ...error });
            track(SERVER_RESPONSE_FAILED, {...generateServerResponseError(error, ACTIVATION, 'Home Page', hnAPI.logout, 'Logout API' )})
            track(MESSAGE_DISPLAYED, {...generateMessageDisplayedSegment(error, ACTIVATION, 'Logout API')});
            dispatch.auth.clearStore();
          });
      },
      async clearStore() {
        dispatch({ type: 'RESET_APP'})
      },
      async checkMaintanence({ onMaintanence, offMaintanence }){
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: "GET",
          url: hnAPI.checkForMaintenence,
        }).then(response => {
          if(get(response.data, 'executionInfo[0].value', '') === 1){
            onMaintanence && onMaintanence(pageURLs.maintenanace);
          } else{
            offMaintanence && offMaintanence();
          }
          dispatch.apiStatus.setProcessing(false);
        })
        .catch(error => {
          dispatch.apiStatus.setProcessing(false);
        })
      }
    };
  }
}
